const aspectRatios = ['16:9', '1:1', '9:16', '4:3', '4:5'];

export default aspectRatios;
